import {createSystem, defaultConfig, defineConfig, defineSlotRecipe, defineTokens} from '@chakra-ui/react'
import {fieldAnatomy, tableAnatomy} from '@chakra-ui/react/anatomy'

const config = defineConfig({
  theme: {
    tokens: defineTokens({
      fonts: {
        heading: {
          value: '"Satoshi"',
        },
        body: {
          value: '"Geist"',
        },
        mono: {
          value: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace',
        },
      },
    }),

    slotRecipes: {
      table: defineSlotRecipe({
        slots: tableAnatomy.keys(),
        base: {
          columnHeader: {
            color: 'fg.subtle',
            fontSize: 'sm',
            fontWeight: 'medium',
          },
        },
      }),

      field: defineSlotRecipe({
        slots: fieldAnatomy.keys(),
        base: {
          helperText: {
            fontFamily: 'body',
            fontSize: 'sm',
            color: 'fg.subtle',
          },
        },
      }),
    },
  },

  globalCss: {
    'button.chakra-button:active': {
      transform: 'scale(0.97)',
    },

    'h1, h2, h3, h4, h5, h6': {
      fontFeatureSettings: "'ss01' on,'ss03' on",
    },

    'p, span, label, legend, th, td': {
      fontFeatureSettings: " 'ss02' on, 'ss04' on, 'ss06' on, 'ss07' on, 'ss08' on, 'ss09' on",
    },
  },
})

export default createSystem(defaultConfig, config)
